<template>
  <div id="contenedor-listado-presupuesto-detalle">
    <v-data-table
      v-if="getDetallesPresupuesto.length > 0"
      :headers="headers"
      :items="getDetallesPresupuesto"
      show-expand
      single-expand
      sort-by="claveObra"
      :items-per-page="1000"
      hide-default-footer
      class="rounded-lg ml-7 mr-n6"
      :item-class="colorRow">
      <!-- <template v-slot:[`item.esPresupuestoOriginal`]="{ item }">
        <v-icon :class="item.esPresupuestoOriginal ? 'success--text': 'error--text'">
          {{ item.esPresupuestoOriginal ? 'check_circle': 'unpublished' }}
        </v-icon>
      </template> -->
      <template v-slot:[`item.claveObra`]="{ item }">
        <small>{{ item.claveObra }}</small>
      </template>
      <template v-slot:[`item.obra.meta`]="{ item }">
        <small>{{ item.obra.meta }}</small>
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        <span>{{ item.importe | currency }}</span>
      </template>
      <template v-slot:[`item.modificado`]="{ item }">
        <span>{{ getImporteModificado(item) | currency }}</span>
      </template>
      <template v-slot:[`item.addModificacion`]="{ item }"
      v-if="mixValidaScopesActions(1)">
        <v-btn
          small
          color="base8"
          class="rounded-lg"
          dark
          @click="preAgregarPresupuestoModificacion(item)">
          <v-icon>add</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
        <v-tooltip top
        v-if="(item.modificaciones.length === 0) && mixValidaScopesActions(3)">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              @click="preEliminarDetalle(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Remover</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }">
        <v-badge
          bordered
          color="error"
          left
          :content="item.modificaciones.length || '0'"
          overlap>
          <v-btn
            small
            color="base2"
            class="rounded-lg"
            dark
            @click="expand(!isExpanded)">
            <span>ver</span>
            <v-icon right>
              {{ isExpanded ? 'expand_less' : 'expand_more' }}
            </v-icon>
          </v-btn>
        </v-badge>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="white"></td>
        <td :colspan="headers.length -1" class="pr-0 base5" >
          <v-data-table
            v-if="item.modificaciones.length > 0"
            :headers="headersModificaciones"
            :items="item.modificaciones"
            sort-by="createdAt"
            dense
            :items-per-page="1000"
            hide-default-footer
            class="base5">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="(modificacion, index) in items" :key="index">
                  <!-- <td>{{ index + 1 }}</td> -->
                  <td>
                    <v-tooltip top
                    v-if="(index === items.length - 1) && mixValidaScopesActions(3)">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          @click="preEliminarModificacion(modificacion)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Remover</span>
                    </v-tooltip>
                  </td>
                  <td>
                    <small>{{ modificacion.numero }}</small>
                  </td>
                  <td>
                    <small>{{ modificacion.justificacion }}</small>
                  </td>
                  <td align="end">
                    <small>{{ modificacion.importe | currency }}</small>
                  </td>
                  <td>
                    <small>{{ modificacion.tipo }}</small>
                  </td>
                  <td>
                    <small>{{ modificacion.fecha }}</small>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </td>
      </template>
    </v-data-table>
    <v-row class="mx-n6 ">
      <v-col cols="12" class="pa-0">
        <v-card
          flat
          class="mt-2"
          :color="nuevosDetalles.length > 0 ? 'base4' : ''">
          <agregar-detalle-presupuesto
            editarPresupuesto
            :presupuestoId="presupuestoId"
            :detalles="nuevosDetalles"
            v-model="formPptoDetalleValido" />
          <v-card-actions v-if="nuevosDetalles.length > 0">
            <v-row justify="center">
              <custom-button
                @click="mixAgregarPresupuestoDetalles"
                :disabled="detallesValidos"
                tipo="formAceptar"
                label="Guardar">
              </custom-button>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-if="agregarModificacion"
      v-model="agregarModificacion"
      width="95%">
      <agregar-presupuesto-modificacion
        :presupuestoId="presupuestoId"
        :presupuestoDetalleId="presupuestoDetalleId"
        v-on:cerrar="agregarModificacion = !agregarModificacion">
      </agregar-presupuesto-modificacion>
    </v-dialog>
    <v-dialog
      v-if="verEliminarDetalle"
      v-model="verEliminarDetalle"
      width="600">
      <v-card>
        <v-card-title class="secondary--text">Eliminar Detalle</v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar este detalle de presupuesto?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="verEliminarDetalle = !verEliminarDetalle"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarPresupuestoDetalle"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="verEliminarModificacion"
      v-model="verEliminarModificacion"
      width="600">
      <v-card>
        <v-card-title class="secondary--text">Eliminar Modificación</v-card-title>
        <v-card-text>
          <span class="secondary--text">
            ¿Desea eliminar esta modificación al presupuesto?
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="verEliminarModificacion = !verEliminarModificacion"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixEliminarPresupuestoModificado"
            :disabled="enviandoFormulario"
            tipo="formAceptar"
            label="Eliminar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import FechaHumano from '@/components/FechaHumano.vue';
// import CustomTextField from '@/components/inputs/TextField.vue';
// import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomButton from '@/components/buttons/Button.vue';
import agregarDetallePresupuesto from '@/components/administracion/presupuestos/presupuestosDetalles/Nuevo.vue';
import mixPresupuestosDetalles from '@/components/administracion/presupuestos/presupuestosDetalles/mixPresupuestosDetalles';
import agregarPresupuestoModificacion from '@/components/administracion/presupuestos/presupuestosDetalles/presupuestosModificaciones/Nuevo.vue';
import mixPresupuestosModificaciones from '@/components/administracion/presupuestos/presupuestosDetalles/presupuestosModificaciones/mixPresupuestosModificaciones';

export default {
  name: 'ListadoPresupuestoDetalle',
  mixins: [mixPresupuestosDetalles, mixPresupuestosModificaciones],
  components: {
    // CustomTextField,
    // CustomTextFieldGreen,
    CustomButton,
    agregarDetallePresupuesto,
    agregarPresupuestoModificacion,
    // FechaHumano,
  },
  props: {
    presupuestoId: String,
    // detalles: Array,
    formularioValido: Boolean,
  },
  data() {
    return {
      agregarModificacion: false,
      formPptoDetalleValido: false,
      verModificaciones: [],
      verEliminarDetalle: false,
      verEliminarModificacion: false,
      presupuestoDetalleId: null,
      modificacionId: null,
      headers: [
        // { text: '#', value: 'no', sortable: false },
        // {
        //   text: '', value: 'acciones', sortable: false, width: '1%',
        // },
        { text: '', value: 'acciones', width: '1%' },
        { text: 'Clave', value: 'claveObra', sortable: false },
        { text: 'Obra', value: 'obra.meta', sortable: false },
        {
          text: 'Autorizado', value: 'importe', sortable: false, align: 'end',
        },
        {
          text: 'Modificado', value: 'modificado', sortable: false, align: 'end',
        },
        {
          text: 'Agregar Modificación',
          value: 'addModificacion',
          sortable: false,
          align: 'center',
          width: '1%',
        },
        { text: 'Ver Modificaciones', value: 'data-table-expand', align: 'center' },
      ],
      headersModificaciones: [
        {
          text: '', value: 'acciones', sortable: false, width: '1%',
        },
        {
          text: 'Número', value: 'numero', sortable: false, width: '1%',
        },
        {
          text: 'Justificación', value: 'justificacion', sortable: false, width: '40%',
        },
        {
          text: 'Modificado', value: 'importe', sortable: false, align: 'end',
        },
        {
          text: 'Tipo', value: 'tipo', sortable: false, width: '1%',
        },
        {
          text: 'Fecha', value: 'fecha', sortable: false, width: '12%',
        },
      ],
    };
  },
  mounted() {
    this.fetchVer();
  },
  methods: {
    fetchVer() {
      this.getDetallesPresupuesto.forEach(() => {
        this.verModificaciones.push(false);
      });
    },
    colorRow(item) {
      if (item.esPresupuestoOriginal) return 'verde1';
      return 'naranja2';
    },
    getImporteModificado({ importe, modificaciones }) {
      const sumaModificaciones = modificaciones.reduce((total, elem) => total + elem.importe, 0);
      return importe + sumaModificaciones;
    },
    cambiarVerModificaciones(i) {
      const valor = !this.verModificaciones[i];
      this.verModificaciones.splice(i, 1, valor);
    },
    preAgregarPresupuestoModificacion({ id }) {
      this.presupuestoDetalleId = id;
      this.agregarModificacion = true;
    },
    preEliminarDetalle({ id }) {
      this.presupuestoDetalleId = id;
      this.verEliminarDetalle = true;
    },
    preEliminarModificacion({ idPresupuestoDetalle, id }) {
      this.presupuestoDetalleId = idPresupuestoDetalle;
      this.modificacionId = id;
      this.verEliminarModificacion = true;
    },
    cerrar() {
      this.$emit('cerrar');
    },
  },
  computed: {
    detallesValidos() {
      return !this.formPptoDetalleValido || this.enviandoFormulario;
    },
  },
};
</script>
